import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=2eb5c4ff&scoped=true"
import script from "./lesson.vue?vue&type=script&lang=js"
export * from "./lesson.vue?vue&type=script&lang=js"
import style0 from "./lesson.vue?vue&type=style&index=0&id=2eb5c4ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb5c4ff",
  null
  
)

export default component.exports